import { motion } from "framer-motion";
import { useLang, STR } from "../i18n";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

export const About = () => {
  const { lang } = useLang();
  const t = STR[lang].about;

  return (
  <section id="studio" className="bg-white" data-testid="about-section">
    <div className="grid lg:grid-cols-[38%_62%] lg:min-h-[560px]">
      <motion.div
        {...reveal}
        className="bg-[#f8fafb] flex flex-col justify-center py-[70px] px-6 lg:pl-[max(24px,calc((100vw-1320px)/2+24px))] lg:pr-[60px]"
      >
        <p className="text-[11px] uppercase tracking-[0.2em] text-[#F18A00] font-bold" data-testid="about-eyebrow">
          {t.eyebrow}
        </p>
        <h2 className="font-display font-medium uppercase text-[34px] lg:text-[40px] leading-[1.05] tracking-[-0.02em] text-[#0D1B2A] mt-[14px]" data-testid="about-title">
          {t.t1}<br />
          <span className="text-[#F18A00]">{t.t2}</span><br />
          {t.t3}
        </h2>
        <p className="mt-6 text-sm text-[#66727b] leading-[1.7] max-w-[420px]" data-testid="about-text-1">
          {t.text}
        </p>
        <a
          href="#contatti"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector("#contatti")?.scrollIntoView({ behavior: "smooth" });
          }}
          data-testid="about-cta-button"
          className="group mt-9 inline-flex items-center gap-6 bg-[#0D1B2A] text-white px-[25px] py-[17px] text-xs uppercase tracking-[0.045em] hover:bg-[#F18A00] transition-colors duration-300 self-start"
        >
          {t.cta} <span className="text-[21px] font-light leading-none transition-transform duration-300 group-hover:translate-x-1">{"→"}</span>
        </a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="relative min-h-[360px] lg:min-h-0 overflow-hidden"
        data-testid="about-photo"
      >
        <img
          src="/assets/studio-soci.webp"
          alt={t.imgAlt}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover grayscale"
        />
        <div
          className="absolute bottom-0 right-0 w-[70%] h-[60%] bg-[#0D1B2A]/85"
          style={{ clipPath: "polygon(30% 100%, 100% 25%, 100% 100%)" }}
          aria-hidden="true"
        />
      </motion.div>
    </div>
  </section>
  );
};
